import { useState } from "react";
import "./AgeMatch.scss";
import ButtonSubmit from "../ButtonSubmit";
import ProgressDots from "../ProgressDots/ProgressDots";
import SelectGlobal from "../SelectGlobal";
import CheckboxOption from "../QuestionCheckbox/CheckboxOption";
import { useWizardAnswers } from "ui-components";
import { simplyClick, getPreferenceAge } from "../../helpers";

const AgeMatch = ({ nextStep, activeDot }) => {
  const [selected, setSelected] = useState([]);
  const [preference, setPreference] = useState({ from: "", to: "" });
  const [disabled, setDisabled] = useState(false);
  const updateAnswer = useWizardAnswers();

  const allAges = getPreferenceAge();
  const fromAge = Number(preference.from);
  const toAge = Number(preference.to);

  const filteredToAges = allAges.filter(
    (age) => Number(age) >= fromAge || !preference.from
  );
  const filteredFromAges = allAges.filter(
    (age) => Number(age) <= toAge || !preference.to
  );

  const handleAction = (action) => {
    simplyClick("cl_lnd_woman_age_st9_action", { text: action });

    if (
      selected.includes("doesnt_matter") ||
      !preference.from ||
      !preference.to
    ) {
      updateAnswer({ age: ["0"] });
    } else {
      updateAnswer({ age: [preference.from, preference.to] });
    }
    if (action === "skip") {
      updateAnswer({ age: ["0"] });
    }

    nextStep();
  };

  const handleSetPreferenceFrom = (event) => {
    const selectedAge = Number(event.target.value);
    setPreference((prev) => {
      let newPref = { ...prev, from: String(selectedAge) };
      if (prev.to && Number(prev.to) < selectedAge) {
        newPref.to = "";
      }
      simplyClick("cl_lnd_woman_age_st9_age", {
        text: `from (${selectedAge})`,
      });
      return newPref;
    });
  };

  const handleSetPreferenceTo = (event) => {
    const selectedAge = Number(event.target.value);
    if (preference.from && selectedAge < Number(preference.from)) {
      return;
    }
    setPreference((prev) => {
      const newPref = { ...prev, to: String(selectedAge) };
      simplyClick("cl_lnd_woman_age_st9_age", {
        text: `to (${selectedAge})`,
      });
      return newPref;
    });
  };

  const handleCheckBoxChange = (value) => {
    let newSelected;

    if (selected.includes(value)) {
      newSelected = [];
      setDisabled(false);
    } else {
      newSelected = [value];
      setPreference({ from: "", to: "" });
      setDisabled(true);
      simplyClick("cl_lnd_woman_age_st9_age", { text: value });
      updateAnswer({ age: ["0"] });
    }

    setSelected(newSelected);
  };

  const isNextDisabled = !preference.from || !preference.to;

  return (
    <div className="radio__form-wrapper">
      <div className="user__form-top">
        <h3>About my match</h3>
      </div>

      <div className="question__form-content">
        <p className="title_question">How old is your best match?</p>

        <div className="select__wrapper">
          <SelectGlobal
            dateArray={filteredFromAges}
            data={preference.from}
            handleChange={handleSetPreferenceFrom}
            label="From"
            error={null}
            customClass=""
            useIndexAsValue={false}
            disabled={disabled}
          />
          <SelectGlobal
            dateArray={filteredToAges}
            data={preference.to}
            handleChange={handleSetPreferenceTo}
            label="To"
            error={null}
            customClass=""
            useIndexAsValue={false}
            disabled={disabled}
          />
        </div>

        <div className="check_age">
          <CheckboxOption
            key="Age doesn’t matter to me"
            label="Age doesn’t matter to me"
            value="doesnt_matter"
            selected={selected}
            onSelect={handleCheckBoxChange}
            disabled={false}
          />
        </div>

        <div className="btn_group">
          <ButtonSubmit
            onClick={() => handleAction("skip")}
            className="button__global button_skip"
            text="SKIP"
          />
          <ButtonSubmit
            onClick={() => handleAction("next")}
            disabled={!selected.includes("doesnt_matter") && isNextDisabled}
            className="button__global"
            text="NEXT"
          />
        </div>

        <ProgressDots total={12} activeCount={activeDot} />
      </div>
    </div>
  );
}

export default AgeMatch;
